import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { TOKEN_API_PUBLIC } from '@/utils/constant.utils';
import { CustomizeResultImage } from '../entities/vehicule-check-result';

const VEHICULE_CHECK_RESULT_URI = '/vehiculeCheckResult';

export const getResultByVehiculeCheckId = async (vehiculeCheckId: string) => {
  return requestApi({
    url: `${VEHICULE_CHECK_RESULT_URI}/vehiculeCheck/${vehiculeCheckId}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
      'x-api-token': TOKEN_API_PUBLIC,
    },
  });
};

export const createVehiculeCheckResult = async (data: object) => {
  return requestApi({
    url: VEHICULE_CHECK_RESULT_URI,
    method: HTTP_METHOD.POST,
    body: data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateVehiculeCheckResult = async (id: string, data: object) => {
  return requestApi({
    url: `${VEHICULE_CHECK_RESULT_URI}/update/${id}`,
    method: HTTP_METHOD.PUT,
    body: data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const uploadVehiculeCheckResultImage = async (formData: FormData) => {
  return requestApi({
    url: `${VEHICULE_CHECK_RESULT_URI}/uploadImageFile`,
    method: HTTP_METHOD.POST,
    body: formData,
  });
};

export const updateResults = async (
  id: string,
  results: object[],
  canModerate: boolean,
  moderationStatus: string
) => {
  return requestApi({
    url: `${VEHICULE_CHECK_RESULT_URI}/updateResults/${id}`,
    method: HTTP_METHOD.PUT,
    body: {
      results,
      canModerate,
      moderationStatus,
    },
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const customizeResultImage = async (data: CustomizeResultImage) => {
  return requestApi({
    url: `${VEHICULE_CHECK_RESULT_URI}/customizeResultImage`,
    method: HTTP_METHOD.PATCH,
    body: data,
    headers: {
      'Content-Type': 'application/json',
      'x-api-token': TOKEN_API_PUBLIC,
    },
  });
};

export const validateReport = async (id: string) => {
  return requestApi({
    url: `${VEHICULE_CHECK_RESULT_URI}/validateReport/${id}`,
    method: HTTP_METHOD.PATCH,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllRepair = async () => {
  return requestApi({
    url: `${VEHICULE_CHECK_RESULT_URI}/repair`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
      'x-api-token': TOKEN_API_PUBLIC,
    },
  });
};

export const deleteManyVehiculeCheckResultsByVehiculeCheckId = async (
  vehiculeCheckId: string
) => {
  return requestApi({
    url: `${VEHICULE_CHECK_RESULT_URI}/deleteManyByVehiculeCheckId/${vehiculeCheckId}`,
    method: HTTP_METHOD.DELETE,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
